import { Component, Input } from '@angular/core';
import { FormElementComponent as _FormElementComponent } from './angular2-schema-form-shim';
import { JSONSchema, SchemaButtonList, FormElementToast } from './types/json-schema';
import { isSchemaButtonGroup } from './forms/schemas';

@Component( {
  selector: 'sp-form-element',
  templateUrl: './formelement.component.html',
} )
export class FormElementComponent extends _FormElementComponent {
  buttons: SchemaButtonList;

  @Input()
  toast: FormElementToast = null;

  protected parseButtons() {
    const schema = this.formProperty.schema as JSONSchema;

    if ( schema.buttons !== undefined ) {
      this.buttons = schema.buttons;

      for ( let button of this.buttons ) {
        const buttons = isSchemaButtonGroup( button ) ? button.buttons : [ button ];

        for ( let _button of buttons ) {
          this.createButtonCallback( _button );
        }

      }
    }
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formelement.component.ts